module.exports = __webpack_public_path__ + "static/media/skinnyLanding2.b2f64447.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/skinnyLanding2.png
// module id = 1233
// module chunks = 0